import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { AdminTestContext } from '@orientaction/Context';
import OaAccordion from '@orientaction/commons/OaAccordion';
import OaPopin from '@orientaction/commons/Popin';
import { useContext, useState } from 'react';
import style from './style';
import { Collapse, IconButton } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ItemAglomeration from './ItemAglomeration';
import Board from './WithDragAndDrop';
import VariableDrawer from './VariableDrawer';
import QuestionDrawer from './QuestionDrawer';
import ResponseDrawer from './ResponseDrawer';

const AglomerationSection = () => {
  const classes = style();
  const [isExpanded, setIsExpanded] = useState<boolean>(true);

  return (
    <div style={{ width: '100%' }}>
      <div style={{ marginTop: 35, marginBottom: 15 }}>
        <div className={classes.sectionTitle} onClick={() => setIsExpanded(!isExpanded)}>
          <Typography component="h1" style={{ color: '#FFFFFF', fontSize: 20, fontWeight: 700, fontFamily: 'Poppins' }}>
            Configuration des variables
          </Typography>
          <IconButton style={{ color: '#FFFFFF', padding: '4px' }}>
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </div>
      </div>
      <Collapse in={isExpanded}>
        <Board />
      </Collapse>
      <VariableDrawer />
      <QuestionDrawer />
      <ResponseDrawer />
    </div>
  );
};

export default AglomerationSection;
